import { render, staticRenderFns } from "./NewPurchaseInvoice.vue?vue&type=template&id=484def94&scoped=true"
import script from "./NewPurchaseInvoice.vue?vue&type=script&lang=js"
export * from "./NewPurchaseInvoice.vue?vue&type=script&lang=js"
import style0 from "./NewPurchaseInvoice.vue?vue&type=style&index=0&id=484def94&prod&lang=css"
import style1 from "./NewPurchaseInvoice.vue?vue&type=style&index=1&id=484def94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484def94",
  null
  
)

export default component.exports